export default "__VITE_ASSET__jQFe9kqM__"